import zappy from '@zappy-ride/library.react.components';
import { OutputLCFS } from './LCFS';

export * from './LCFS';

zappy.FactoryInstance.registerComponent(OutputLCFS);
